import Step7 from './Step7';

export default Step7;
